import enums from 'utilities/enums';
import DateManager from 'utilities/services/DateManager';

export const extractGeneralEntityInformation = data => ({
  name: `${data.firstName} ${data.lastName}`,
  countryId: data.nationality,
  assignedUserName: data.assignedUser,
  status: data.status,
  riskLevel: data.riskLevel,
  amlIssues: data.amlIssues,
  kycIssues: data.kycIssues,
  assignedUserId: data.assignedUserId,
  nextReview: data.nextReview,
  riskScore: data.score,
  riskLevelCalculationMethod: data.riskLevelCalculationMethod,
  riskLevelEnabled: data.riskLevelEnabled,
});

const replaceNull = value => value || '';

export const extractPersonalInfo = data => ({
  firstName: replaceNull(data.firstName),
  middleName: replaceNull(data.middleName),
  lastName: replaceNull(data.lastName),
  birthDate: DateManager.toDate(data.birthDate),
  phone: replaceNull(data.phone),
  email: replaceNull(data.email),
  nationality: replaceNull(data.nationality),
  residence: replaceNull(data.residence),
  unit: replaceNull(data.unit),
  streetAddress: replaceNull(data.streetAddress),
  postalZip: replaceNull(data.postalZip),
  city: replaceNull(data.city),
  stateProvince: replaceNull(data.stateProvince),
  additionalDetails: replaceNull(data.additionalDetails),
  association: replaceNull(data.association),
  registrationNumber: replaceNull(data.registrationNumber),
  pendingDeletion: data.pendingDeletion,
  geoLocation: replaceNull(data.geoLocation),
});

export const extractIssues = data => ({
  personal: {
    value: data.personalInformationIssuesCount,
    index: enums.ACCORDION_INDEXES.PERSONAL_INFORMATION,
    shouldFocus: false,
    isAllRejected: data.allPersonalEventsRejected,
  },
  identity: {
    value: data.identityDocumentsIssuesCount,
    index: enums.ACCORDION_INDEXES.IDENTITY_DOCUMENTS,
    shouldFocus: false,
    isAllRejected: data.allIdentityDocumentsRejected,
  },
  biometric: {
    value: data.faceMatchingIssuesCount,
    index: enums.ACCORDION_INDEXES.BIOMETRIC_AUTHENTICATIONS,
    shouldFocus: false,
    isAllRejected: data.allFaceMatchsRejected,
  },
  documents: {
    value: data.documentsIssuesCount,
    index: enums.ACCORDION_INDEXES.DOCUMENTS,
    shouldFocus: false,
    isAllRejected: data.allDocumentsRejected,
  },
  riskScreening: { value: data.amlIssuesCount, index: enums.ACCORDION_INDEXES.RISK_SCREENING, shouldFocus: false },
});
